import React from 'react';
import Locale from "../util/Locale";

function Gdpr() {

    return (
        <div className="dark:bg-gray-800 flex-grow">
            <div>
                <div className="animation-fade active absolute top-0 z-50 h-full bg-gray-900 w-full undefined"></div>
                <section>
                    <div className="py-8 px-4 mx-auto max-w-screen-xl lg:py-16 lg:px-6 ">
                        <Locale code={'gdpr'}/>
                    </div>
                </section>
            </div>
        </div>
    );
}

export default Gdpr;
